export default __webpack_public_path__ + "locales/de/JavascriptSdk.json?hash=01a8dac9ed221d697734d5f1904066b6";